import React from 'react'

import S from './styled'
import { getTheme } from '../../themes'

const theme = getTheme()

export const LoadingCircles = ({ overlay }) => (
  <S.Loading overlay={overlay}><div></div></S.Loading>
)

const Loading = ({ overlay, container }) => (
  <S.Loading overlay={overlay} container={container} loadingAniation={theme.loadingAniation}><img src={theme.logo} alt="..."/></S.Loading>
)

export default Loading
